<template>
    <line-chart :labels="labels" :datasets="datasets" paddingTop="24" style="height: 210px" ref="chart" />
</template>

<script>
import LineChart from "@/components/common/LineChart";

export default {
    name: "EvaluationDatesChart",
    components: { LineChart },
    props: {
        values: {
            type: Array,
            default: null,
        },
        ideal: {
            type: [Number, String],
            default: null,
        },
        compare: {
            type: Array,
            default: null,
        },
        compareLabel: {
            type: String,
            default: null,
        },
    },
    data(vm) {
        return {
            datasets: [],
            labels: [],
            options: { layout: { padding: { top: 26 } } }
        }
    },
    computed: {
        isDark(vm = this) {
            return vm.$vuetify.theme.dark
        },
    },
    mounted() {
        const vm = this
        vm.loadChart()

    },
    methods: {
        loadChart() {
            const vm = this
            vm.datasets = []
            vm.labels = []
            let data = []
            let labelsSet = new Set();

            vm.values?.forEach((val, i) => {
                if (val.actual > 0) {
                    labelsSet.add(val.date);
                    data.push(val.actual);
                }
            })

            const theme = vm.$vuetify.theme.currentTheme
            const lineColor = theme.success
            let gradientFill = this.$refs.chart.$refs.canvas.getContext('2d').createLinearGradient(0, 40, 0, 250);
            gradientFill.addColorStop(0, 'rgba(0,153,102,0.32)');
            gradientFill.addColorStop(1, 'rgba(0,153,102,0)');

            let labels = Array.from(labelsSet).sort((a, b) => vm.$moment(a, 'DD MMM').toDate() - vm.$moment(b, 'DD MMM').toDate());
            vm.labels = labels;

            const datasets = [{
                label: vm.$t('common.actual'),
                data: data,
                borderColor: lineColor,
                backgroundColor: gradientFill,
                pointBackgroundColor: lineColor,
                pointBorderColor: theme.surface,
                pointRadius: 4,
                pointHoverRadius: 5,
                pointBorderWidth: 2,
                borderWidth: 2.2,
                lineTension: 0.35,
                fill: true,
                type: 'line',
                order: 2,
            }]

            const idealValue = parseFloat(vm.ideal)
            if (!isNaN(idealValue) && data.length) {
                datasets.push({
                    label: vm.$t('common.ideal'),
                    data: data.map(() => idealValue),
                    borderColor: theme.accent,
                    borderDash: [5, 3],
                    borderWidth: 1.5,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    fill: false,
                    type: 'line',
                    order: 1,
                })
            }

            if (vm.compare?.length) {
                const compareByDate = {}
                vm.compare.forEach(val => { if (val.actual > 0) compareByDate[val.date] = val.actual })
                const compareData = labels.map(label => compareByDate[label] != null ? compareByDate[label] : null)

                if (compareData.some(value => value !== null)) datasets.push({
                    label: vm.compareLabel || vm.$t('common.group'),
                    data: compareData,
                    borderColor: theme.secondary,
                    borderDash: [4, 3],
                    borderWidth: 2,
                    pointBackgroundColor: theme.secondary,
                    pointBorderColor: theme.surface,
                    pointRadius: 3,
                    pointHoverRadius: 4,
                    pointBorderWidth: 2,
                    lineTension: 0.35,
                    fill: false,
                    spanGaps: true,
                    type: 'line',
                    order: 1,
                })
            }

            vm.datasets = datasets
        },
    },
    watch: {
        values() {
            this.loadChart()
        },
        compare() {
            this.loadChart()
        },
        ideal() {
            this.loadChart()
        },
        isDark() {
            this.loadChart()
        },
    }
}
</script>

<style scoped></style>